import {
  createFeature,
  createReducer,
  createSelector,
  on,
  provideState,
} from '@ngrx/store';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { UserInfoActions } from './user-info.actions';
import { UserInfoEffects } from './user-info.effects';
import { getAccountNumber } from '../../../utils/userProfile';

export const defaultFirstName = 'Customer';

export const initialState: Readonly<UserInfo> = {
  firstName: defaultFirstName,
  lastName: '',
  userName: defaultFirstName,
  emailAddress: '',
  accountNumber: '',
};

export const userInfoFeature = createFeature({
  name: 'userInfo',
  reducer: createReducer(
    initialState,
    on(UserInfoActions.getUserInfoSuccess, (state, { userInfo }) => {
      return {
        ...state,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        userName: userInfo.firstName + ' ' + userInfo.lastName,
        emailAddress: userInfo.emailAddress,
        accountNumber: getAccountNumber(),
      };
    }),
    on(UserInfoActions.setCustomerFirstName, (state, { firstName }) => {
      return {
        ...state,
        firstName,
      };
    }),
    on(UserInfoActions.setCustomerLastName, (state, { lastName }) => {
      return {
        ...state,
        lastName,
      };
    }),
    on(UserInfoActions.setCustomerFirstAndLastName, (state, { firstName }) => {
      return {
        ...state,
        firstName: firstName,
        lastName: '',
      };
    })
  ),
});

export const selectCustomerName = createSelector(
  userInfoFeature.selectFirstName,
  userInfoFeature.selectLastName,
  (firstName, lastName) => {
    return firstName + ' ' + lastName;
  }
);

export const {
  selectFirstName,
  selectLastName,
  selectUserName,
  selectEmailAddress,
  selectAccountNumber,
} = userInfoFeature;

export function provideUserInfoFeature() {
  return makeEnvironmentProviders([
    provideState(userInfoFeature),
    provideEffects(UserInfoEffects),
  ]);
}
